import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BarArrowButton from './BarArrowButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NewsShoutPanel',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(BarArrowButton, {
                class: "bar",
                flex: true,
                large: true,
                title: "Your Daily News",
                href: "/#/PersonalNews"
            }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "barArrowButtonSlotContent" }, [
                        _createElementVNode("a", { href: "/#/PersonalNews" }, [
                            _createElementVNode("p", null, "Your personalised, friendly, finance-flavoured news catch-up!"),
                            _createElementVNode("div", {
                                class: "printer-stage",
                                "aria-hidden": "true"
                            }, [
                                _createElementVNode("div", { class: "printer" }, [
                                    _createElementVNode("div", { class: "printer-body" }, [
                                        _createElementVNode("div", { class: "printer-slot" }),
                                        _createElementVNode("div", { class: "printer-light" })
                                    ]),
                                    _createElementVNode("div", { class: "paper" }, [
                                        _createElementVNode("div", { class: "headline" }),
                                        _createElementVNode("div", { class: "line line-1" }),
                                        _createElementVNode("div", { class: "line line-2" }),
                                        _createElementVNode("div", { class: "line line-3" }),
                                        _createElementVNode("div", { class: "line line-4" })
                                    ])
                                ])
                            ])
                        ])
                    ], -1)
                ])),
                _: 1
            }));
        };
    }
});
